import { Platform } from 'react-native';

const platforms = {
  web: 'web',
  ios: 'ios',
  android: 'android',
  windows: 'windows',
  macos: 'macos',
};

type Platforms = keyof typeof platforms;

export function usePlatformStyles(
  platform: Platforms = Platform.OS as Platforms
): (styles: Record<string, any>) => Record<string, any> | null {
  return function (styles) {
    return Platform.OS === platform ? styles : null;
  };
}
